import { render, staticRenderFns } from "./AuroReleases.vue?vue&type=template&id=cd3b0a70&"
import script from "./AuroReleases.vue?vue&type=script&lang=js&"
export * from "./AuroReleases.vue?vue&type=script&lang=js&"
import style0 from "./AuroReleases.vue?vue&type=style&index=0&id=cd3b0a70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports